import { AxiosResponse } from 'axios';
import internalApiClient from '~/app/shared/util/api/internalApiClient';

import { Dimension, DimensionLine, DimensionValue, DistributionKey } from '../types';

export function getDimensionLines(
    dimensionId: number,
    includeDistributionKeys?: false,
    includeBarred?: boolean
): Promise<AxiosResponse<DimensionValue[]>>;
export function getDimensionLines(
    dimensionId: number,
    includeDistributionKeys?: true,
    includeBarred?: boolean
): Promise<AxiosResponse<DimensionLine[]>>;
export function getDimensionLines(
    dimensionId: number,
    includeDistributionKeys?: boolean,
    includeBarred?: boolean
): Promise<AxiosResponse<DimensionValue[] | DimensionLine[]>>;
export function getDimensionLines(
    dimensionId: number,
    includeDistributionKeys = true,
    includeBarred = false
): Promise<AxiosResponse<DimensionValue[] | DimensionLine[]>> {
    return internalApiClient
        .get<Dimension>(
            `/dimension/${dimensionId}?includeDistributionKeys=${includeDistributionKeys}&includeBarred=${includeBarred}`
        )
        .then(res => {
            return {
                ...res,
                data: res.data?.lines,
            };
        })
        .catch(err => err);
}

type UpsertDimensionValueType = Omit<DimensionValue, 'type'>;
export function createDimensionValue({ type, ...value }: DimensionValue): Promise<AxiosResponse> {
    return internalApiClient.post<undefined, AxiosResponse, UpsertDimensionValueType>(
        `dimension/${value.dimensionId}/dimensionvalue`,
        value
    );
}

export function getDimensionValueById(dimensionId: number, id: number): Promise<AxiosResponse<DistributionKey>> {
    return internalApiClient.get<DistributionKey>(`/dimension/${dimensionId}/dimensionvalue/${id}`);
}

export function updateDimensionValue({ type, ...value }: DimensionValue): Promise<AxiosResponse> {
    return internalApiClient.put<undefined, AxiosResponse, UpsertDimensionValueType>(
        `dimension/${value.dimensionId}/dimensionvalue`,
        value
    );
}

export function deleteDimensionValue(dimensionId: number, id: number): Promise<AxiosResponse> {
    return internalApiClient.delete(`dimension/${dimensionId}/dimensionvalue/${id}`);
}

type UpsertDistributionKeyType = Omit<DistributionKey, 'type'>;
export function createDistributionKey({ type, ...value }: DistributionKey): Promise<AxiosResponse> {
    return internalApiClient.post<undefined, AxiosResponse, UpsertDistributionKeyType>(
        `dimension/${value.dimensionId}/distributionkey`,
        value
    );
}

export function getDistributionKeyById(dimensionId: number, id: number): Promise<AxiosResponse<DistributionKey>> {
    return internalApiClient.get<DistributionKey>(`/dimension/${dimensionId}/distributionkey/${id}`);
}

export function updateDistributionKey(value: DistributionKey): Promise<AxiosResponse> {
    return internalApiClient.put<undefined, AxiosResponse, DistributionKey>(
        `/dimension/${value.dimensionId}/distributionKey`,
        value
    );
}

export function deleteDistributionKey(dimensionId: number, id: number): Promise<AxiosResponse> {
    return internalApiClient.delete(`/dimension/${dimensionId}/distributionkey/${id}`);
}
